import "core-js/modules/es.array.push.js";
import axios from "axios";
import moment from "moment";
import CryptoJS from "crypto-js";
import global from "./global";
// 引入 Element Plus 图标
import { View, Hide } from "@element-plus/icons-vue";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  components: {
    View,
    Hide
  },
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      memberList: [],
      memberNotSave: {},
      selectedUserId: 0,
      positionList: ["校长", "管理员", "老师", "教务", "顾问", "助教", "财务", "访客", "其他"],
      // 密码显示状态 (key: userId, value: true/false)
      decryptedPasswordList: [],
      passwordVisible: {},
      newPassword: "",
      showNewPassword: false,
      showAddUser: false,
      addUserObj: {
        name: "",
        phone: "",
        position: "其他"
      },
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: ""
    };
  },
  async mounted() {
    await this.getMemberList();
  },
  methods: {
    // 获取机构的人员
    async getMemberList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/peopleManagement/peopleManagement/getAllMember", params);
        if (resp1.data.code == "0000") {
          this.memberList = resp1.data.data;

          // 每个用户的权限
          for (let i = 0; i < this.memberList.length; i++) {
            // 每个用户的权限
            if (!this.memberList[i].roles) {
              this.memberList[i].roles = ["查看", "编辑"];
            } else {
              this.memberList[i].roles = JSON.parse(this.memberList[i].roles);
            }
          }

          // 每个用户密码解密
          for (let i = 0; i < this.memberList.length; i++) {
            let encryptedPassword = this.memberList[i].password;

            // 解密的密码，单独一个变量保存, 防止传memberList的时候泄露
            this.decryptedPasswordList[i] = CryptoJS.AES.decrypt(encryptedPassword, global.keyArray.join("")).toString(CryptoJS.enc.Utf8);
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    selectUser(userId) {
      this.selectedUserId = userId;
    },
    // 修改姓名
    nameChange(index) {
      let userId = this.memberList[index].id;
      this.memberNotSave[userId] = true;
    },
    // 修改手机号
    phoneChange(index) {
      let userId = this.memberList[index].id;
      this.memberNotSave[userId] = true;
    },
    // 点击职位, 展开下拉框
    clickPosition(index) {
      let refName = "positionSelectRef" + index;

      // 通过 ref 获取 el-select 实例
      const select = this.$refs[refName];
      console.log("select:", select);
      if (select[0]) {
        // 调用 toggleMenu 方法展开下拉菜单
        select[0].toggleMenu();
      }
    },
    // 修改职位
    positionChange(index) {
      let userId = this.memberList[index].id;
      this.memberNotSave[userId] = true;
    },
    // 修改权限
    roleChange(index) {
      let userId = this.memberList[index].id;

      // console.log(
      //   "this.memberList[index].roles:",
      //   this.memberList[index].roles
      // );

      this.memberNotSave[userId] = true;
    },
    // 保存信息修改
    async saveInfoChange() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let userList = [];
        for (let i in this.memberList) {
          if (this.memberNotSave[this.memberList[i].id] == true) {
            userList.push(this.memberList[i]);

            // 如果手机号格式不对
            if (!this.validatePhone(this.memberList[i].phone)) {
              return;
            }
          }
        }
        let params = {
          userList: userList
        };
        let resp1 = await axios.post("https://backend.wonology.com/peopleManagement/peopleManagement/saveInfo", params);
        if (resp1.data.code == "0000") {
          // 重新获取人员信息
          await this.getMemberList();

          //
          for (let key in this.memberNotSave) {
            this.memberNotSave[key] = false;
          }

          // 更新当前用户信息
          let userId = this.userInfo.id;
          let userIndex = this.memberList.findIndex(item => item.id == userId);
          this.userInfo = this.memberList[userIndex];
          sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          this.$emit("updateVariable");
          console.log("this.userInfo:", this.userInfo);
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 切换密码显示/隐藏
    togglePassword(userId) {
      // 如果该用户还没有初始化，默认为 false(隐藏)
      if (this.passwordVisible[userId] === undefined) {
        this.passwordVisible[userId] = false;
      }
      // 切换状态
      this.passwordVisible[userId] = !this.passwordVisible[userId];
    },
    // 增加人员
    addUser() {
      this.showAddUser = true;
    },
    async addUserConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 校验手机号
        let phoneValidate = this.validatePhone(this.addUserObj.phone);
        if (!phoneValidate) {
          // alert("请输入正确的手机号");

          return;
        }
        let params = {
          addUserObj: this.addUserObj,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/peopleManagement/peopleManagement/addMember", params);
        if (resp1.data.code == "0000") {
          // 重新获取人员列表
          await this.getMemberList();
          this.showAddUser = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    addUserCancel() {
      this.showAddUser = false;
    },
    // 校验手机号
    validatePhone(phone) {
      // 手机号正则表达式 (11位数字，以1开头, 第二个必须是3-9，剩下9个数字)
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(phone)) {
        alert("请输入正确的手机号");
        return false;
      }
      return true;
    },
    // 重置密码
    resetPassword() {
      if (!this.selectedUserId) {
        alert("请选择人员");
        return;
      }
      this.newPassword = this.generateRandomSixDigitNumber();
      this.showNewPassword = true;
    },
    // 重置密码确认
    async resetPasswordConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let userList = [];
        for (let i in this.memberList) {
          // 只需要修改选中的账号的密码
          if (this.memberList[i].id == this.selectedUserId) {
            console.log("this.newPassword:", this.newPassword);
            // 新密码加密
            let encryptedPassword = CryptoJS.AES.encrypt(this.newPassword.toString(), global.keyArray.join("") // 将数组转换为字符串作为密钥
            ).toString();
            this.memberList[i].password = encryptedPassword;
            userList.push(this.memberList[i]);
          }
        }
        let params = {
          userList: userList
        };
        let resp1 = await axios.post("https://backend.wonology.com/peopleManagement/peopleManagement/saveInfo", params);
        if (resp1.data.code == "0000") {
          // 重新获取人员信息
          await this.getMemberList();
          this.showNewPassword = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    resetPasswordCancel() {
      this.showNewPassword = false;
    },
    // 生成六位随机数字
    generateRandomSixDigitNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    // 停用人员
    async deleteUser() {
      if (!this.selectedUserId) {
        alert("请选择人员");
        return;
      }
      this.showTip = true;
      this.tipMessage = "确认删除？";
      // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
      // 后面通过 this.tipResolver(value) 返回值
      const tipConfirmed = await new Promise(resolve => {
        this.tipResolver = resolve;
      });
      if (tipConfirmed === "confirm") {
        // 用户选择确认，继续执行

        this.showTip = false;
        // 重置变量
        this.tipMessage = "";
        this.tipNeedInput = false;
      } else {
        // 用户选择取消，返回

        return;
      }

      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          userId: this.selectedUserId
        };
        let resp1 = await axios.post("https://backend.wonology.com/peopleManagement/peopleManagement/deleteMember", params);
        if (resp1.data.code == "0000") {
          // 重新获取人员列表
          await this.getMemberList();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    }
  }
};